import { connect } from 'react-redux';
import SEARCH_CONTEXT from '../../../helpers/InventorySearchContext';
import { getIsFetching } from '../../../redux/Inventory/selectors/item/availability';
import { getSearchQueryForContext } from '../../../redux/Inventory/selectors/components/search';
import {
  getItemTagsSearchOptions,
  getIsFetchingItemTagsOptions,
  getItemAvailabilityLocationZonesOptions,
  getIsFetchingItemAvailabilityLocationZonesOptions
} from '../../../redux/Inventory/selectors/components/search-options';
import {
  onChangeQuery,
  onClearQuery
} from '../../../redux/Inventory/actions/components/search';
import { clearInventoryItemsAvailability } from '../../../redux/Inventory/actions/item';
import {
  fetchInventoryItemsAvailability,
  fetchInventoryItemTagsOptions,
  fetchInventoryItemAvailabilityLocationZoneOptions
} from '../../../redux/Inventory/sagas/routines';
import AvailabilitySearch from '../../../components/inventory/AvailabilitySearch';

function mapStateToProps(state, props) {
  const searchQuery = getSearchQueryForContext(
    state,
    SEARCH_CONTEXT.ITEM_AVAILABILITY
  );
  return {
    ...props,
    searchQuery,
    tagsOptions: getItemTagsSearchOptions(state),
    locationZoneOptions: getItemAvailabilityLocationZonesOptions(state),
    isFetching: getIsFetching(state),
    isFetchingTagsOptions: getIsFetchingItemTagsOptions(state),
    isFetchingLocationZoneOptions: getIsFetchingItemAvailabilityLocationZonesOptions(
      state
    )
  };
}

function mapDispatchToProps(dispatch) {
  const context = SEARCH_CONTEXT.ITEM_AVAILABILITY;
  return {
    onInit: () => {
      dispatch(fetchInventoryItemTagsOptions());
      dispatch(fetchInventoryItemAvailabilityLocationZoneOptions());
    },
    onSubmit: queryOptions => {
      dispatch(clearInventoryItemsAvailability());
      dispatch(fetchInventoryItemsAvailability(queryOptions));
    },
    onChange: query => {
      dispatch(onChangeQuery({ context, query }));
    },
    onClear: () => {
      dispatch(onClearQuery({ context }));
      dispatch(clearInventoryItemsAvailability());
      dispatch(fetchInventoryItemsAvailability({}));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AvailabilitySearch);
